import React, { Fragment } from "react";
import _ from "lodash";
import { Col, Form, Button, Accordion, Card } from "react-bootstrap";
import { COLOR_INPUT_PATTERN } from "../RetailerWidgetSettingsConstants";
import styles from "./RetailerWidgetSettings.module.scss";
import commonStyles from "../RetailerWidgetSettings.module.scss";

const RetailerWidgetSettingsFormView = ({
    handleSubmit,
    values,
    handleChange,
    isSubmitting,
    widgetToken,
}) => {
    const customWidgetSettingsJson = JSON.stringify({
        token: widgetToken,
        ..._.pickBy(values, (v) => !!v),
    });

    return (
        <Fragment>
            <Accordion>
                <Accordion.Toggle
                    className={commonStyles.accordionToggle}
                    as={Card.Header}
                    eventKey="0"
                >
                    Button Install Code <i className="bi bi-chevron-down"></i>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <div className={styles.widgetCodeWrapper}>
                        <section>
                            <p>
                                Insert the following code just before the
                                closing <code>&lt;/body&gt;</code> tag on your
                                website.
                            </p>

                            <pre>
                                {`<script>
    (function (w, d, s, o, f, js, fjs) {
    w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
    js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
    js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
    }(window, document, 'script', '_tote', 'https://js.bookwithtote.com/widget${
        CONFIG.env !== "prod" ? ".dev" : ""
    }.js'));
    _tote('init', ${customWidgetSettingsJson});
</script>`}
                            </pre>
                        </section>
                    </div>
                </Accordion.Collapse>
            </Accordion>

            <Accordion>
                <Accordion.Toggle
                    className={commonStyles.accordionToggle}
                    as={Card.Header}
                    eventKey="0"
                >
                    Personalize your button{" "}
                    <i className="bi bi-chevron-down"></i>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <Fragment>
                        <p>
                            You can change the colors and text of your button
                            here. When you're done, you'll need to copy the
                            updated button code above onto your website.
                        </p>

                        <Form onSubmit={handleSubmit}>
                            <Form.Row>
                                <Col md={4}>
                                    <Form.Group controlId="input-widget-button-text">
                                        <Form.Label>Button text</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="buttonText"
                                            value={values.buttonText}
                                            placeholder="Personalize Your Visit!"
                                            maxLength="25"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="input-widget-button-color">
                                        <Form.Label>
                                            Button color (RGB hex)
                                        </Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="buttonColor"
                                            value={values.buttonColor}
                                            pattern={COLOR_INPUT_PATTERN}
                                            minLength="4"
                                            maxLength="7"
                                            placeholder="#B0C4B1"
                                            onBlur={(e) =>
                                                e.target.reportValidity()
                                            }
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="input-widget-button-text-color">
                                        <Form.Label>
                                            Button text color (RGB hex)
                                        </Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="buttonTextColor"
                                            value={values.buttonTextColor}
                                            pattern={COLOR_INPUT_PATTERN}
                                            minLength="4"
                                            maxLength="7"
                                            placeholder="#000000"
                                            onBlur={(e) =>
                                                e.target.reportValidity()
                                            }
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Form.Row>
                            <Form.Row>
                                <Col md={4}>
                                    <Form.Group controlId="input-widget-theme-color">
                                        <Form.Label>
                                            Theme color (RGB hex)
                                        </Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="themeColor"
                                            value={values.themeColor}
                                            pattern={COLOR_INPUT_PATTERN}
                                            minLength="4"
                                            maxLength="7"
                                            placeholder="#D8B4A0"
                                            onBlur={(e) =>
                                                e.target.reportValidity()
                                            }
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="input-widget-theme-text-color">
                                        <Form.Label>
                                            Theme text color (RGB hex)
                                        </Form.Label>
                                        <Form.Control
                                            type="color"
                                            name="themeTextColor"
                                            value={values.themeTextColor}
                                            pattern={COLOR_INPUT_PATTERN}
                                            minLength="4"
                                            maxLength="7"
                                            placeholder="#223843"
                                            onBlur={(e) =>
                                                e.target.reportValidity()
                                            }
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="input-widget-theme-text-color">
                                        <Form.Label>Button position</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="position"
                                            value={values.position}
                                            onChange={handleChange}
                                        >
                                            <option value="">
                                                Bottom-right corner
                                            </option>
                                            <option value="bottom-left">
                                                Bottom-left corner
                                            </option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Form.Row>
                            {/* <Form.Row>
                                <Col md={4}>
                                    <Form.Group controlId="input-widget-content-statement-text">
                                        <Form.Label>
                                            Questionnaire header
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="contentStatementText"
                                            value={values.contentStatementText}
                                            placeholder="Welcome to Kurt Lyle! Discounts every day!"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Form.Row> */}

                            <Button
                                disabled={isSubmitting}
                                type="submit"
                                className="mb-4"
                            >
                                Save
                            </Button>
                        </Form>
                    </Fragment>
                </Accordion.Collapse>
            </Accordion>
        </Fragment>
    );
};

export default RetailerWidgetSettingsFormView;
